var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520.09 309.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-8{fill:#00bed6;}.cls-1,.cls-6,.cls-7{stroke:#00bed6;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-6,.cls-7,.cls-9{stroke-miterlimit:10;}.cls-1{stroke-width:22px;}.cls-2{opacity:0.49;}.cls-3{opacity:0.7;}.cls-4{fill:#fff;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-5,.cls-6,.cls-7,.cls-9{fill:none;}.cls-10,.cls-6{stroke-width:3px;}.cls-13,.cls-7{stroke-width:4px;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-9{stroke:#fff;}.cls-9{stroke-width:2px;}.cls-12{stroke-width:6px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.27,207.69H877.51V395.76l-251.07,99-247-99Z",
    transform: "translate(-368.42 -196.69)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M406.76,309.59l1.05.73,3.64-.89,2.46,10.16s.25.42,1.07.22l18.46-4.47-.1,12-11.7,2.83a6.06,6.06,0,0,1-3.91,2.67,5.23,5.23,0,0,1-4.33-.67s-1-.2-1.17,1.29l-1.14,9.84a6.69,6.69,0,0,1-6.2,5.61s-5.93.58-7.08-6.14c0,0-2.08-10-1.65-18.17l.35-6.51a43.44,43.44,0,0,1,1.63-5.71,1.84,1.84,0,0,1,.87-.93Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M437,302.27l-.61,1.12-3.63.89,2.46,10.15s0,.49-.85.69l-18.46,4.48,5.59,10.64,11.7-2.84a6.1,6.1,0,0,0,4.7.58,5.24,5.24,0,0,0,3.54-2.58s.79-.64,1.64.6l5.52,8.24a6.67,6.67,0,0,0,8.08,2.14s5.53-2.2,3.48-8.7c0,0-2.73-9.84-6.86-16.9L450,305.15a43.25,43.25,0,0,0-4.07-4.33,1.84,1.84,0,0,0-1.19-.43Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M412,309.21l19.92-4.83,2.34,9.63a.62.62,0,0,1-.31.68l-19.06,4.62a.6.6,0,0,1-.54-.4Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M399.33,310.27l.11.46,6.48-1.57-.11-.46A10.26,10.26,0,0,0,399.33,310.27Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M436.93,301.15l.12.46,6.47-1.57-.11-.46A10.26,10.26,0,0,0,436.93,301.15Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M437.2,301.09l.11.46,6.48-1.57-.12-.46A10.23,10.23,0,0,0,437.2,301.09Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M411.61,318.47a6.81,6.81,0,1,1-8.25-5.12A6.88,6.88,0,0,1,411.61,318.47Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M449.79,309.21a6.81,6.81,0,1,1-8.24-5.12A6.87,6.87,0,0,1,449.79,309.21Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M420,326a3.82,3.82,0,1,1-4.63-2.88A3.86,3.86,0,0,1,420,326Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M440.74,321a3.82,3.82,0,1,1-4.63-2.87A3.86,3.86,0,0,1,440.74,321Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M427.17,324.27a1,1,0,1,1-1.18-.74A1,1,0,0,1,427.17,324.27Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M441.11,311.34a1.52,1.52,0,1,1-1.85-1.15A1.54,1.54,0,0,1,441.11,311.34Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M448.25,309.58a1.52,1.52,0,1,1-1.84-1.14A1.53,1.53,0,0,1,448.25,309.58Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M443.67,307a1.52,1.52,0,1,1-1.85-1.14A1.54,1.54,0,0,1,443.67,307Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M445.49,313.92a1.53,1.53,0,0,1-1.11,1.86,1.55,1.55,0,1,1,1.11-1.86Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M410.88,312.74a.43.43,0,0,1-.32.53h0A.43.43,0,0,1,410,313l-.43-1.75a.45.45,0,0,1,.32-.54h0a.46.46,0,0,1,.54.33Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M435.51,306.91a.45.45,0,0,1-.32.54h0a.46.46,0,0,1-.54-.33l-.42-1.75a.43.43,0,0,1,.32-.53h0a.43.43,0,0,1,.53.32Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M423.68,319.57a.33.33,0,0,1-.24.39h0a.32.32,0,0,1-.39-.24v0a.32.32,0,0,1,.24-.39h0a.33.33,0,0,1,.39.24Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M424.39,320.29a.32.32,0,0,1-.24.39h0a.32.32,0,0,1-.39-.23v0A.33.33,0,0,1,424,320h0a.32.32,0,0,1,.39.24Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M425.47,320a.32.32,0,0,1-.24.39h0a.32.32,0,0,1-.39-.24v0a.32.32,0,0,1,.24-.39h0a.31.31,0,0,1,.39.23Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M425.19,321.07a.32.32,0,0,1-.23.39h0a.34.34,0,0,1-.4-.24v0a.33.33,0,0,1,.24-.4h0a.33.33,0,0,1,.39.24Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M426.38,320.78a.32.32,0,0,1-.24.39h0a.32.32,0,0,1-.39-.24v0a.32.32,0,0,1,.24-.39h0a.31.31,0,0,1,.39.24Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M426,321.62a.33.33,0,0,1-.24.39h0a.32.32,0,0,1-.39-.24v0a.32.32,0,0,1,.24-.39h0a.32.32,0,0,1,.39.24Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M426.65,319.74a.32.32,0,0,1-.24.39h0a.32.32,0,0,1-.39-.23v0a.31.31,0,0,1,.24-.39h0a.33.33,0,0,1,.39.24Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M424.77,319.3a.32.32,0,0,1-.24.39h0a.31.31,0,0,1-.39-.23v0a.33.33,0,0,1,.24-.39h0a.32.32,0,0,1,.39.24Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M426,319a.33.33,0,0,1-.24.4h0a.33.33,0,0,1-.39-.24v0a.32.32,0,0,1,.23-.39h0a.34.34,0,0,1,.4.24Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M427.09,318.74a.31.31,0,0,1-.24.39h0a.33.33,0,0,1-.39-.24v0a.33.33,0,0,1,.24-.4h0a.33.33,0,0,1,.39.24Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "30.8 122.95 34.13 122.15 36.08 123.53 34.98 125.66 31.65 126.46 30.8 122.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "41.46 120.37 38.13 121.18 37.03 123.3 38.98 124.69 42.31 123.88 41.46 120.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "33.6 118.37 34.4 121.7 36.53 122.8 37.91 120.85 37.1 117.52 33.6 118.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "39.73 128.36 38.92 125.03 36.8 123.93 35.42 125.88 36.22 129.21 39.73 128.36"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M737.54,201.35l.69,1.07,3.69.6-1.65,10.32s.06.48.9.62l18.76,3-4.74,11L743.3,226.1a6.08,6.08,0,0,1-4.64,1,5.19,5.19,0,0,1-3.73-2.29s-.84-.57-1.59.73l-4.85,8.64a6.68,6.68,0,0,1-7.88,2.78s-5.7-1.76-4.17-8.4c0,0,1.95-10,5.51-17.39l2.84-5.87a44,44,0,0,1,3.71-4.64,1.84,1.84,0,0,1,1.16-.52Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M768.22,206.28l-1,.8-3.7-.6-1.65,10.33s-.22.43-1,.3l-18.76-3,1,12L755,228a6.06,6.06,0,0,0,4.1,2.35,5.23,5.23,0,0,0,4.26-1s1-.29,1.28,1.18l1.91,9.73a6.67,6.67,0,0,0,6.62,5.1s6,.12,6.58-6.67c0,0,1.28-10.14.2-18.24l-.85-6.47a45.57,45.57,0,0,0-2.08-5.57,1.8,1.8,0,0,0-.93-.85Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M742.54,203l20.24,3.25-1.57,9.78a.62.62,0,0,1-.55.51l-19.36-3.1a.59.59,0,0,1-.34-.58Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M730.42,199.11l-.07.46,6.58,1.06.07-.47A10.23,10.23,0,0,0,730.42,199.11Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M768.63,205.23l-.08.47,6.58,1.06.08-.47A10.22,10.22,0,0,0,768.63,205.23Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M768.9,205.28l-.08.47,6.58,1.05.08-.47A10.25,10.25,0,0,0,768.9,205.28Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M738.57,211.41a6.8,6.8,0,1,1-5.62-7.9A6.84,6.84,0,0,1,738.57,211.41Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M777.37,217.64a6.81,6.81,0,1,1-5.63-7.91A6.87,6.87,0,0,1,777.37,217.64Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M743.39,221.61a3.82,3.82,0,1,1-3.15-4.44A3.86,3.86,0,0,1,743.39,221.61Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M764.47,225a3.82,3.82,0,1,1-3.15-4.44A3.85,3.85,0,0,1,764.47,225Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M750.68,222.78a1,1,0,1,1-1.92-.31,1,1,0,0,1,1.12-.83A1,1,0,0,1,750.68,222.78Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M768.54,216.24a1.52,1.52,0,1,1-1.26-1.77A1.54,1.54,0,0,1,768.54,216.24Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M775.81,217.39a1.52,1.52,0,1,1-1.26-1.77A1.53,1.53,0,0,1,775.81,217.39Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M772.59,213.21a1.52,1.52,0,1,1-1.26-1.77A1.54,1.54,0,0,1,772.59,213.21Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M771.59,220.32a1.52,1.52,0,1,1-1.26-1.77A1.53,1.53,0,0,1,771.59,220.32Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M740.12,205.85a.45.45,0,0,1-.5.37h0a.45.45,0,0,1-.37-.51l.29-1.78a.43.43,0,0,1,.5-.36h0a.43.43,0,0,1,.37.5Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M765.09,210a.44.44,0,0,1-.51.36h0a.43.43,0,0,1-.36-.5l.29-1.78a.43.43,0,0,1,.5-.37h0a.44.44,0,0,1,.36.51Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M749.28,217.09a.32.32,0,0,1-.37.27h0a.32.32,0,0,1-.27-.37v0a.33.33,0,0,1,.37-.27h0a.34.34,0,0,1,.27.38Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M749.66,218a.34.34,0,0,1-.37.27h0a.33.33,0,0,1-.27-.38v0a.32.32,0,0,1,.37-.27h0a.32.32,0,0,1,.27.37Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M750.76,218.21a.32.32,0,0,1-.37.27h0a.32.32,0,0,1-.27-.37v0a.32.32,0,0,1,.37-.26h0a.31.31,0,0,1,.27.37Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M750.1,219.06a.32.32,0,0,1-.37.27h0a.32.32,0,0,1-.27-.37v0a.32.32,0,0,1,.37-.26h0a.33.33,0,0,1,.27.37Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M751.31,219.26a.32.32,0,0,1-.37.26h0a.31.31,0,0,1-.27-.37v0a.32.32,0,0,1,.37-.27h0a.32.32,0,0,1,.27.37Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M750.63,219.88a.32.32,0,0,1-.37.27h0a.32.32,0,0,1-.27-.37v0a.33.33,0,0,1,.38-.26h0a.32.32,0,0,1,.26.37Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M752,218.41a.32.32,0,0,1-.37.26h0a.31.31,0,0,1-.27-.37v0a.32.32,0,0,1,.37-.27h0a.32.32,0,0,1,.27.37Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M750.39,217.27a.32.32,0,0,1-.37.27h0a.32.32,0,0,1-.27-.37v0a.33.33,0,0,1,.38-.27h0a.32.32,0,0,1,.26.37Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M751.59,217.46a.31.31,0,0,1-.37.27h0a.32.32,0,0,1-.26-.37v0a.32.32,0,0,1,.37-.26h0a.31.31,0,0,1,.27.37Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M752.75,217.65a.31.31,0,0,1-.37.27h0a.32.32,0,0,1-.26-.37v0a.32.32,0,0,1,.37-.27h0a.32.32,0,0,1,.27.37Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "358.28 11.02 361.66 11.56 362.93 13.59 361.09 15.13 357.71 14.58 358.28 11.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "369.11 12.76 365.73 12.21 363.89 13.75 365.16 15.78 368.54 16.32 369.11 12.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "362.63 7.87 362.09 11.26 363.62 13.09 365.65 11.83 366.19 8.45 362.63 7.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "364.43 19.45 364.97 16.07 363.44 14.23 361.41 15.5 360.87 18.88 364.43 19.45"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M830.58,258.38l-.07.1h0Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M845.34,228.17l-15.63-3a1.36,1.36,0,0,0-1.59,1.08l0,.21a1.38,1.38,0,0,0,1.09,1.6l15.62,3a1.34,1.34,0,0,0,1-.19l.31-2.28a1.3,1.3,0,0,0-.74-.41",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M827.48,262c-.59,1.77-1.55,2.39-2.79,2s-12.62-4.42-13.36-4.69a3.15,3.15,0,0,0,0,.53l14.79,5.58,4.4-6.94a.88.88,0,0,0,0-.44c-1-.38-2.26,1.78-3,4",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M871.82,235.14l-9.29-1.76-.21,1.1,9.11,1.73a.82.82,0,0,0,.39-1.07",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M871.46,236.22l-8.79-1.68a10.36,10.36,0,0,1-.33,1l-2.07,1.12c-.11.19-.24.39-.38.59l-3.87-.57a.25.25,0,0,1,0,.07l-3.44-.56.24-1.69a10,10,0,0,1-1,2.06l-6.77.2.25-1.9a23,23,0,0,1-.77,2.2l-3,.08.1.17s-2.39-.11-2.51.41-.59,3-.72,3.69-.3,1.44-1.18,1.27l-1.88-.36,0,.24c-.07.26-1,.59-1.18.74s-.26,1-.41,1.71-1.36,1.26-1.61,1.61a12.39,12.39,0,0,0-.46,2.35c-.12.5-.5.64-1.11,1.27a9,9,0,0,0-1.59,4.51,3.57,3.57,0,0,0,1.27,2.79,1,1,0,0,1,.35.47h0s6.07,2.57,6.9,3,.62,1.07.4,2-2.34,8.71-2.71,10.14-1.11,1.57-2,1.41-20.75-6.33-21.81-6.75-2.41-1.46-2-2.93,1.92-5.56,1.92-5.56l0,0c.17-2.08,2.08-4.73,3.19-5.86a13.07,13.07,0,0,0,2.12-3.51s.5.09,2.34.63,2.77-.33,4.19-4,5.21-7.73,6.88-9.14,2.35-1.68,2.71-3.55a3.81,3.81,0,0,0-2.58-4c-1.4-.48-9.33-3.15-10.62-3.4a3.78,3.78,0,0,0-2.09.12c2.71-5.13,6.56-5.11,8.58-4.86,16.14,2,20.12,3.26,20.12,3.26a16,16,0,0,1,.17,1.67l.17-1.22,6.6,1.87a11.8,11.8,0,0,1,.36,2.48l.26-1.74,3.85.83a.62.62,0,0,0,0,.09l3.59.92a3.88,3.88,0,0,1,.1.45l1.67,2.06a4.86,4.86,0,0,1-.05,1l8.78,1.68c.31,0,.34.32.28.62s-.18.54-.49.48",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M861.27,230.38l-.22-.27,0,0L859.7,237l.57-.31a9.3,9.3,0,0,0,1-6.31",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M857.58,229l-.32-.08-1.47,7.74.23,0a12.15,12.15,0,0,0,1.56-7.7",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M845.17,232.51,837,231a.72.72,0,0,0-.84.57l0,.11a.72.72,0,0,0,.57.84l8.19,1.56a.73.73,0,0,0,.46-.07l.18-1.27a.78.78,0,0,0-.35-.18",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "449.04 29.95 449 53.46 447.88 53.24 448.06 30.77 449.04 29.95"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M624.65,257.6v.12h0Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M626.48,224l15.09,5a1.35,1.35,0,0,1,.86,1.72l-.06.21a1.37,1.37,0,0,1-1.72.86l-15.1-5a1.34,1.34,0,0,1-.76-.64l.84-2.15a1.45,1.45,0,0,1,.85,0",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M625.57,262.29c-.35,1.83.19,2.84,1.48,3.08s13.17,2.29,14,2.43a5,5,0,0,1-.25.46l-15.63-2.33-.47-8.21a.91.91,0,0,1,.25-.37c1.08.18,1.1,2.66.67,4.94",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M600,217.21l9,3-.36,1.07-8.8-2.92a.82.82,0,0,1,.18-1.13",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M599.74,218.33l8.5,2.82c-.15.6-.22,1.06-.22,1.06l1.27,2a5.43,5.43,0,0,0,0,.69l3.66,1.4v.08l3.28,1.19.61-1.59a10.3,10.3,0,0,0-.09,2.31l5.82,3.47.7-1.78a22.27,22.27,0,0,0-.39,2.29l2.56,1.52-.18.11s2.14,1.07,2,1.58-.95,2.9-1.17,3.57-.44,1.4.41,1.68l1.82.61-.07.23c-.07.26.58,1,.67,1.22a6.35,6.35,0,0,1-.48,1.7c-.2.67.57,1.76.62,2.18a12.65,12.65,0,0,1-.74,2.29c-.14.48.12.79.35,1.65a9,9,0,0,1-.81,4.7,3.58,3.58,0,0,1-2.48,1.82.94.94,0,0,0-.52.24h0s-6.55-.72-7.47-.79-1.06.64-1.32,1.55-2.2,8.74-2.58,10.17.22,1.91,1,2.18,21.2,4.59,22.34,4.73,2.81-.1,3.16-1.58,1-5.79,1-5.79h0c.87-1.89.49-5.13.07-6.66a13,13,0,0,1-.14-4.1s-.48-.16-2.35-.6-2.26-1.63-1.72-5.5-.79-9.28-1.55-11.33-1.24-2.61-.64-4.43a3.8,3.8,0,0,1,4.21-2.24c1.45.26,9.68,1.8,10.92,2.21a3.77,3.77,0,0,1,1.77,1.12c.14-5.8-3.24-7.66-5.12-8.43-15.07-6.1-19.16-7-19.16-7-.35.45-.67.91-1,1.38l.45-1.14-6.67-1.59a12,12,0,0,0-1.53,2l.63-1.64-3.77-1.16,0,.07-3.58-.95s-.13.13-.32.35l-2.45,1a5,5,0,0,0-.45.9l-8.48-2.82c-.3-.1-.45.11-.55.41s-.1.56.19.66",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M611.48,218.19l.34-.13,0,0-2.22,6.7-.35-.55a9.42,9.42,0,0,1,2.19-6",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M615.38,218.79l.31.09-2.48,7.48-.22-.08a12.22,12.22,0,0,1,2.39-7.49",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M624.51,227.9l7.91,2.63a.71.71,0,0,1,.45.91l0,.1a.72.72,0,0,1-.9.46L624,229.37a.74.74,0,0,1-.36-.29l.46-1.19a.74.74,0,0,1,.39,0",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "283.15 39.59 271.73 60.14 272.8 60.49 283.61 40.79 283.15 39.59"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M811.73,321.49l10.53,24.35a4.26,4.26,0,0,0,5.61,2.23l15.07-6.51a15.82,15.82,0,0,0,15.88-6.87l10.26-4.43a4.27,4.27,0,0,0,2.22-5.62l-10.52-24.35Zm43.8-17.69a1.36,1.36,0,1,1-.71,1.79A1.35,1.35,0,0,1,855.53,303.8Zm-33.08,18.07c.49,1.15,8.6,19.91,8.6,19.91l-2.52,1.09s-8.21-19-8.89-20.56,2-4.08,2.8-3.79S822,320.73,822.45,321.87Zm27.8,15.05a13.85,13.85,0,1,1,7.21-18.21A13.86,13.86,0,0,1,850.25,336.92Zm18.17-11.85-5.49,2.37-1.3-3,5.48-2.37Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M855.14,298l-.22.1-1.39-3.21-8.16,3.53,1.38,3.19c-2.09.62-5.68-3.29-5.68-3.29l-12.8,5.53s.32,5.63-1.64,6.48h0l-1.31-3-8.16,3.53,1.31,3-4.51,1.95a4.26,4.26,0,0,0-2.45,4.88l48.91-21.13A4.28,4.28,0,0,0,855.14,298Zm-12.86,6.27-9.72,4.2L831,304.8l9.72-4.2Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M841.94,317.58a7.32,7.32,0,1,0,9.62,3.81A7.32,7.32,0,0,0,841.94,317.58Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M840.83,315.14a9.88,9.88,0,1,0,13,5.15A9.88,9.88,0,0,0,840.83,315.14ZM848,331.61a8,8,0,1,1,4.16-10.48A8,8,0,0,1,848,331.61Z",
    transform: "translate(-368.42 -196.69)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M541.69,273.45l-3.46,26.3a4.27,4.27,0,0,0,3.68,4.79l16.27,2.14a15.8,15.8,0,0,0,17.16,2.26l11.08,1.45a4.27,4.27,0,0,0,4.79-3.67l3.46-26.31Zm46.67,7.28a1.36,1.36,0,1,1-1.53,1.17A1.36,1.36,0,0,1,588.36,280.73Zm-37.67-1.46c-.16,1.24-2.82,21.51-2.82,21.51l-2.73-.36s2.7-20.52,2.92-22.21,3.79-2.48,4.35-1.82S550.85,278,550.69,279.27Zm16.15,27.18a13.85,13.85,0,1,1,15.53-11.92A13.84,13.84,0,0,1,566.84,306.45Zm21.67-.85-5.92-.78.43-3.26,5.92.78Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M591,275.57l-.25,0,.46-3.47-8.82-1.16-.45,3.44c-2.11-.53-3.18-5.73-3.18-5.73l-13.83-1.82s-2.61,5-4.73,4.72h0l.42-3.27-8.81-1.16-.43,3.27-4.86-.64a4.26,4.26,0,0,0-4.62,2.94l52.83,6.94A4.26,4.26,0,0,0,591,275.57Zm-14.26-1.22L566.24,273l.52-4,10.5,1.38Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M569.63,285.59a7.31,7.31,0,1,0,6.3,8.2A7.31,7.31,0,0,0,569.63,285.59Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M569.93,282.93a9.87,9.87,0,1,0,8.5,11.08A9.88,9.88,0,0,0,569.93,282.93Zm-2.29,17.82a8,8,0,1,1,9-6.87A8,8,0,0,1,567.64,300.75Z",
    transform: "translate(-368.42 -196.69)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M657.58,335.68c0,.17-.78.55-1.86.83L615,347.25c-1.08.29-2,.37-2,.19l-2.26-8.55c-.05-.18.79-.55,1.86-.84l40.74-10.74c1.07-.28,2-.37,2-.19Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 626.07,
    y: 399.08,
    width: 4.93,
    height: 5.17,
    rx: 1.2,
    transform: "matrix(0.97, -0.25, 0.25, 0.97, -450.01, -23.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 667.71,
    y: 388.1,
    width: 4.93,
    height: 5.17,
    rx: 1.2,
    transform: "matrix(0.97, -0.26, 0.26, 0.97, -445.94, -12.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M675.25,386.87a2.38,2.38,0,0,1-1.7,2.92l-48.39,12.76a2.38,2.38,0,0,1-2.92-1.7L606,339.36a2.41,2.41,0,0,1,1.7-2.93l48.4-12.76a2.4,2.4,0,0,1,2.92,1.71Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M669.84,373.45a2.39,2.39,0,0,1-1.7,2.93l-44.89,11.83a2.38,2.38,0,0,1-2.92-1.7l-8.87-33.64a2.39,2.39,0,0,1,1.7-2.92l44.89-11.83a2.38,2.38,0,0,1,2.92,1.7Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 620.78,
    y: 351.41,
    width: 39.44,
    height: 22.36,
    transform: "translate(-439.7 -21.41) rotate(-14.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 624.59,
    y: 375.59,
    width: 39.44,
    height: 2.92,
    transform: "translate(-443.26 -19.95) rotate(-14.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M659.86,341.92a1,1,0,0,1-.73,1.26l-44.41,11.71a1,1,0,0,1-1.26-.74h0a1,1,0,0,1,.74-1.26l44.4-11.71a1,1,0,0,1,1.26.74Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M627.45,338.69a2.46,2.46,0,1,1-3-1.75A2.47,2.47,0,0,1,627.45,338.69Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M618.76,341a2.46,2.46,0,1,1-3-1.75A2.46,2.46,0,0,1,618.76,341Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.14,336.4a2.46,2.46,0,1,1-3-1.75A2.46,2.46,0,0,1,636.14,336.4Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M644.82,334.11a2.46,2.46,0,0,1-4.75,1.26,2.46,2.46,0,1,1,4.75-1.26Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M653.51,331.82a2.46,2.46,0,1,1-3-1.75A2.45,2.45,0,0,1,653.51,331.82Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M617.46,343.08a.66.66,0,0,1-.48.81h0a.66.66,0,0,1-.8-.47l-.87-3.28a.67.67,0,0,1,.47-.81h0a.66.66,0,0,1,.81.47Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M626.14,340.79a.66.66,0,0,1-.47.81h0a.67.67,0,0,1-.81-.47l-.86-3.28a.66.66,0,0,1,.47-.81h0a.67.67,0,0,1,.81.47Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M634.83,338.5a.66.66,0,0,1-.47.81h0a.67.67,0,0,1-.81-.47l-.86-3.28a.65.65,0,0,1,.47-.81h0a.67.67,0,0,1,.81.47Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M643.52,336.21a.67.67,0,0,1-.47.81h0a.67.67,0,0,1-.81-.47l-.86-3.28a.65.65,0,0,1,.47-.81h0a.66.66,0,0,1,.8.47Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M652.21,333.92a.67.67,0,0,1-.47.81h0a.66.66,0,0,1-.81-.47l-.87-3.28a.66.66,0,0,1,.48-.81h0a.65.65,0,0,1,.8.47Z",
    transform: "translate(-368.42 -196.69)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M512,221.05c0,.18-.94.16-2-.05l-41.37-7.93c-1.09-.22-2-.53-1.91-.71l1.66-8.69c0-.18.95-.16,2,.05l41.38,7.93c1.09.21,1.95.53,1.91.71Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 454.64,
    y: 265.52,
    width: 5.17,
    height: 4.93,
    rx: 1.2,
    transform: "translate(-260.69 469.7) rotate(-79.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 496.93,
    y: 273.63,
    width: 5.17,
    height: 4.93,
    rx: 1.2,
    transform: "translate(-234.17 517.95) rotate(-79.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M505.74,274.85a2.39,2.39,0,0,1-2.8,1.9l-49.15-9.42a2.4,2.4,0,0,1-1.89-2.81l12-62.45a2.39,2.39,0,0,1,2.8-1.9l49.15,9.42a2.39,2.39,0,0,1,1.9,2.8Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M506.67,260.41a2.39,2.39,0,0,1-2.8,1.9l-45.6-8.74a2.39,2.39,0,0,1-1.89-2.8l6.55-34.16a2.39,2.39,0,0,1,2.8-1.9l45.59,8.74a2.39,2.39,0,0,1,1.9,2.8Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 473.73,
    y: 218.22,
    width: 22.36,
    height: 39.44,
    transform: "translate(-208.52 472.66) rotate(-79.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 480.63,
    y: 232.89,
    width: 2.92,
    height: 39.44,
    transform: "translate(-225.21 481.82) rotate(-79.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M511.31,227.66a1,1,0,0,1-1.21.82L465,219.84a1,1,0,0,1-.82-1.21h0a1,1,0,0,1,1.21-.83l45.1,8.65a1,1,0,0,1,.82,1.21Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M483.48,210.74a2.46,2.46,0,1,1-2-2.88A2.47,2.47,0,0,1,483.48,210.74Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M474.65,209.05a2.45,2.45,0,1,1-1.95-2.88A2.46,2.46,0,0,1,474.65,209.05Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M492.3,212.43a2.45,2.45,0,1,1-1.95-2.88A2.45,2.45,0,0,1,492.3,212.43Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M501.13,214.12a2.46,2.46,0,1,1-2-2.87A2.46,2.46,0,0,1,501.13,214.12Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M510,215.82a2.46,2.46,0,1,1-1.95-2.88A2.47,2.47,0,0,1,510,215.82Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M472.57,210.37a.67.67,0,0,1-.78.53h0a.66.66,0,0,1-.52-.77l.64-3.34a.66.66,0,0,1,.77-.52h0a.66.66,0,0,1,.53.77Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.39,212.07a.65.65,0,0,1-.77.52h0a.66.66,0,0,1-.53-.77l.64-3.34a.67.67,0,0,1,.78-.52h0a.65.65,0,0,1,.52.77Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M490.22,213.76a.66.66,0,0,1-.78.52h0a.65.65,0,0,1-.52-.77l.64-3.33a.66.66,0,0,1,.77-.53h0a.66.66,0,0,1,.53.77Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M499,215.45a.67.67,0,0,1-.77.53h0a.67.67,0,0,1-.53-.78l.64-3.33a.68.68,0,0,1,.78-.53h0a.67.67,0,0,1,.52.78Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M507.87,217.14a.67.67,0,0,1-.78.53h0a.66.66,0,0,1-.52-.78l.64-3.33A.65.65,0,0,1,508,213h0a.65.65,0,0,1,.53.77Z",
    transform: "translate(-368.42 -196.69)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M426.68,267.76a19.47,19.47,0,1,1-11-25.48A19.63,19.63,0,0,1,426.68,267.76Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "38.27 29.98 46.12 33.04 46.01 43.62 45.67 44.48 44.52 43.49 38.47 29.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "64.7 39.97 56.84 36.91 49.69 45.02 49.34 45.91 50.87 45.94 64.91 39.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "45.42 23.74 46.05 31.38 38.82 28.57 45.42 23.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "63 30.58 64.52 38.56 57.91 35.99 63 30.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "55.41 27.63 62.11 30.23 56.93 35.61 55.41 27.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "53.54 26.9 46.85 24.3 47.03 31.76 53.54 26.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "54.56 26.88 56.26 35.35 48.1 32.18 54.56 26.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "47.54 33.6 55.71 36.78 48.17 45.2 46.65 44.61 47.54 33.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M778,372.39a19.46,19.46,0,1,1-26.51-8.17A19.61,19.61,0,0,1,778,372.39Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "365.35 164.28 372.76 160.28 380.75 167.22 381.19 168.04 379.68 168.27 365.08 163.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "390.09 150.63 382.67 154.62 384.2 165.33 384.65 166.17 385.67 165.03 389.81 150.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "365.23 154.78 371.45 159.26 364.63 162.94 365.23 154.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "381.83 145.83 388.9 149.85 382.66 153.22 381.83 145.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "374.67 149.69 380.99 146.28 381.74 153.72 374.67 149.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "372.9 150.65 366.58 154.06 372.38 158.76 372.9 150.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "373.55 149.86 381.1 154.06 373.39 158.21 373.55 149.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "374.12 159.56 381.83 155.41 383.35 166.6 381.92 167.37 374.12 159.56"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M559.84,335.16l-66.44,1a1.17,1.17,0,0,0-1.16,1.19l.55,37.31a1.17,1.17,0,0,0,1.19,1.16l66.44-1a1.18,1.18,0,0,0,1.16-1.2L561,336.32A1.18,1.18,0,0,0,559.84,335.16Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M526.82,379.22a.78.78,0,0,1-.73.83l-16.56,1.22a.79.79,0,0,1-.83-.73h0a.79.79,0,0,1,.73-.83L526,378.49a.78.78,0,0,1,.83.73Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M527.7,379.21a.78.78,0,0,0,.75.81l16.59.73a.79.79,0,0,0,.81-.75h0a.78.78,0,0,0-.76-.81l-16.58-.73a.77.77,0,0,0-.81.75Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M526.73,379.65a.78.78,0,0,1-.65.89l-19.15,3.09a.78.78,0,0,1-.9-.64h0a.78.78,0,0,1,.65-.9L525.84,379a.78.78,0,0,1,.89.65Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M527.8,379.63a.79.79,0,0,0,.67.88L547.71,383a.79.79,0,0,0,.88-.67h0a.79.79,0,0,0-.67-.88L528.68,379a.78.78,0,0,0-.88.67Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M529.94,375.38l-1.47,5.13a8.65,8.65,0,0,0-2.39,0l-1.61-5.08Z",
    transform: "translate(-368.42 -196.69)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M768.44,280.05,704,263.73a1.18,1.18,0,0,0-1.43.85l-9.17,36.17a1.18,1.18,0,0,0,.85,1.43L758.7,318.5a1.18,1.18,0,0,0,1.43-.85l9.17-36.17A1.17,1.17,0,0,0,768.44,280.05Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M725.11,314a.77.77,0,0,1-.92.61l-16.3-3.13a.77.77,0,0,1-.61-.92h0a.78.78,0,0,1,.91-.61l16.31,3.13a.78.78,0,0,1,.61.92Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M726,314.23a.78.78,0,0,0,.52,1l15.83,5a.78.78,0,0,0,1-.52h0a.78.78,0,0,0-.51-1l-15.83-5a.78.78,0,0,0-1,.51Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M724.91,314.41a.76.76,0,0,1-.85.69l-19.31-2a.77.77,0,0,1-.69-.85h0a.78.78,0,0,1,.85-.7l19.31,2a.77.77,0,0,1,.69.86Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M726,314.67a.79.79,0,0,0,.42,1l17.92,7.44a.79.79,0,0,0,1-.42h0a.79.79,0,0,0-.43-1L727,314.25a.78.78,0,0,0-1,.42Z",
    transform: "translate(-368.42 -196.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M729.12,311.12l-2.75,4.57a8.83,8.83,0,0,0-2.31-.59l-.24-5.33Z",
    transform: "translate(-368.42 -196.69)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground6);
export default __webpack_public_path__ + "static/media/background6.5745ad01be4121372fd6871524fd808e.svg";
export { ForwardRef as ReactComponent };